// App-side delegate for `@heidi/patients/data` (D2.2, ARCFE-1020).
// isAuthenticated stays app-side and crosses as a boolean (cohort-C); every call
// site keeps its exact signature.
import { useIsAuthenticated } from '@/hooks/useIsAuthenticated';
import {
  GET_PATIENT_RECAP,
  invalidatePatientRecap,
  useQueryPatientRecap as useQueryPatientRecapCore,
} from '@heidi/patients/data';

export { GET_PATIENT_RECAP, invalidatePatientRecap };

export function useQueryPatientRecap(patientProfileId: string | null | undefined) {
  const { isAuthenticated } = useIsAuthenticated();

  return useQueryPatientRecapCore(patientProfileId, isAuthenticated);
}
